/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import docApi from "api";

const getHyperlinkApis = stores => {
  function getLinkAnnots(pageIndex, includeSignData) {
    return docApi.getLinkAnnots(pageIndex, includeSignData);
  }

  function deleteLinkAnnot(pageIndex, id, linkData) {
    return docApi.deleteLinkAnnot(pageIndex, id, linkData);
  }

  function deleteLinkAnnots(links) {
    return docApi.deleteLinkAnnots(links);
  }

  function editLinkAnnot(pageIndex, id, linkData) {
    return docApi.editLinkAnnot(pageIndex, id, linkData);
  }

  function editLinkAnnots(links) {
    return docApi.editLinkAnnots(links);
  }

  function createLinkAnnot(pageIndex, linkData) {
    return docApi.createLinkAnnot(pageIndex, linkData);
  }

  return {
    createLinkAnnot,
    getLinkAnnots,
    editLinkAnnot,
    editLinkAnnots,
    deleteLinkAnnot,
    deleteLinkAnnots
  };
};

export { getHyperlinkApis };
